import Axios from "axios";
import {
  SET_ATTENDANCE_RECONCILIATION_REPORT,
  UNSET_ATTENDANCE_RECONCILIATION_REPORT,
} from "@/store/mutation-types";
import {
  getAttendanceReconciliationReport,
} from "@/store/api";

const state = {
  attendanceReconciliationReport: [],
};

const getters = {
  getAttendanceReconciliationReport(state) {
    return state.attendanceReconciliationReport;
  },
};

const mutations = {
  [SET_ATTENDANCE_RECONCILIATION_REPORT](state, data) {
    state.attendanceReconciliationReport = data;
  },
  [UNSET_ATTENDANCE_RECONCILIATION_REPORT](state) {
    state.attendanceReconciliationReport = [];
  },
};

const actions = {
  getAttendanceReconciliationReport({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(`${getAttendanceReconciliationReport}`, { params: data })
        .then((response) => {
          commit(SET_ATTENDANCE_RECONCILIATION_REPORT, response.data.data || []);
          resolve(response.data);
        })
        .catch((error) => {
          commit(UNSET_ATTENDANCE_RECONCILIATION_REPORT);
          reject(error);
        })
        .finally(() => {
          commit("UNSET_LOADING", null, { root: true });
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

